"use strict";

exports.__esModule = true;
exports.getValueAtPath = getValueAtPath;
var ramdaPath = require("ramda").path;
function getValueAtPath(object, path) {
  return ramdaPath(path, object);
}